import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const GUIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="GU" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#4564F9"
        fillRule="evenodd"
        d="M1.6 1.6h12.8v8.8H1.6V1.6Z"
        clipRule="evenodd"
      />
      <Path
        stroke="#CBDAFF"
        strokeOpacity={0.12}
        d="M13.9 2.1v7.8H2.1V2.1h11.8Z"
      />
      <Mask
        id="b"
        width={14}
        height={10}
        x={1}
        y={1}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M1.6 1.6h12.8v8.8H1.6V1.6Z"
          clipRule="evenodd"
        />
        <Path stroke="#fff" d="M13.9 2.1v7.8H2.1V2.1h11.8Z" />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#CCE0E5"
          stroke="#6D87FB"
          strokeWidth={1.45}
          d="M8.525 1.752h.002l.003.003.01.005.028.014c.024.013.057.03.098.054a7.317 7.317 0 0 1 1.324.96c.71.652 1.535 1.7 1.535 3.085 0 1.372-.813 2.48-1.508 3.186a8.32 8.32 0 0 1-1.43 1.155l-.012.007h-.002l-.373-.62.373.621-.38.228-.376-.234-.002-.001-.003-.002-.008-.005-.028-.019a7.861 7.861 0 0 1-.42-.297 8.743 8.743 0 0 1-.976-.859c-.689-.708-1.505-1.816-1.505-3.16 0-1.357.83-2.405 1.532-3.058A7.68 7.68 0 0 1 7.82 1.781l.028-.016.009-.004.003-.001.002-.001.33-.173.332.166Z"
          opacity={0.4}
        />
        <Path
          fill="#CCE0E5"
          d="m8.2 8.959-.402.604.394.262.4-.256-.392-.61Zm0 0 .393.61v-.002h.003l.007-.005a3.004 3.004 0 0 0 .1-.07 6.715 6.715 0 0 0 1.03-.91c.549-.596 1.192-1.535 1.192-2.698 0-1.175-.654-2.067-1.216-2.62a5.85 5.85 0 0 0-1.13-.864l-.023-.013-.007-.004-.003-.002h-.002V2.38h-.001l-.35-.189-.349.196.199.352c-.18-.318-.198-.348-.2-.351l-.003.002-.008.004a2.497 2.497 0 0 0-.102.061 6.134 6.134 0 0 0-1.042.83c-.555.554-1.213 1.446-1.213 2.599 0 1.14.646 2.08 1.188 2.678a7.043 7.043 0 0 0 1.023.922c.032.024.059.041.077.054l.023.017.007.005h.003v.002l.404-.603Z"
        />
        <Path
          stroke="#C1C9F1"
          strokeOpacity={0.748}
          strokeWidth={1.45}
          d="m8.2 8.959-.402.604.394.262.4-.256-.392-.61Zm0 0 .393.61v-.002h.003l.007-.005a3.004 3.004 0 0 0 .1-.07 6.715 6.715 0 0 0 1.03-.91c.549-.596 1.192-1.535 1.192-2.698 0-1.175-.654-2.067-1.216-2.62a5.85 5.85 0 0 0-1.13-.864l-.023-.013-.007-.004-.003-.002h-.002V2.38h-.001l-.35-.189-.349.196.199.352c-.18-.318-.198-.348-.2-.351l-.003.002-.008.004a2.497 2.497 0 0 0-.102.061 6.134 6.134 0 0 0-1.042.83c-.555.554-1.213 1.446-1.213 2.599 0 1.14.646 2.08 1.188 2.678a7.043 7.043 0 0 0 1.023.922c.032.024.059.041.077.054l.023.017.007.005h.003v.002l.404-.603Z"
        />
        <Path
          stroke="#C51918"
          strokeWidth={1.45}
          d="m8.2 8.959-.402.604.394.262.4-.256-.392-.61Zm0 0 .393.61v-.002h.003l.007-.005a3.004 3.004 0 0 0 .1-.07 6.715 6.715 0 0 0 1.03-.91c.549-.596 1.192-1.535 1.192-2.698 0-1.175-.654-2.067-1.216-2.62a5.85 5.85 0 0 0-1.13-.864l-.023-.013-.007-.004-.003-.002h-.002V2.38h-.001l-.35-.189-.349.196.199.352c-.18-.318-.198-.348-.2-.351l-.003.002-.008.004a2.497 2.497 0 0 0-.102.061 6.134 6.134 0 0 0-1.042.83c-.555.554-1.213 1.446-1.213 2.599 0 1.14.646 2.08 1.188 2.678a7.043 7.043 0 0 0 1.023.922c.032.024.059.041.077.054l.023.017.007.005h.003v.002l.404-.603Z"
        />
        <Mask
          id="c"
          width={5}
          height={6}
          x={6}
          y={3}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            d="M8.206 3.89c.144.105.316.24.485.406.438.431.784.973.784 1.588 0 .627-.357 1.226-.81 1.719-.158.172-.32.318-.46.436a5.443 5.443 0 0 1-.468-.452c-.458-.505-.812-1.104-.812-1.703 0-.587.342-1.129.787-1.572.172-.172.347-.313.494-.422Zm.35-.24h-.002.002Z"
          />
          <Path
            stroke="#fff"
            strokeWidth={1.45}
            d="M8.206 3.89c.144.105.316.24.485.406.438.431.784.973.784 1.588 0 .627-.357 1.226-.81 1.719-.158.172-.32.318-.46.436a5.443 5.443 0 0 1-.468-.452c-.458-.505-.812-1.104-.812-1.703 0-.587.342-1.129.787-1.572.172-.172.347-.313.494-.422Zm.35-.24h-.002.002Z"
          />
        </Mask>
        <G mask="url(#c)">
          <Path fill="#91CBCB" d="M6.467 7H10.2v.75H6.467z" />
          <Path
            fill="#FDF9A1"
            fillRule="evenodd"
            d="M6.8 7.6s2.648 0 2.891-.091c.243-.092-.457 1.753-1.351 1.753C7.446 9.262 6.8 7.6 6.8 7.6Z"
            clipRule="evenodd"
          />
          <Path
            fill="#A68861"
            d="m9.297 7.378-.476.366c-.75-.974-1.064-1.982-.93-3.01l.596.078c-.113.86.153 1.712.81 2.566Z"
          />
          <Path
            fill="#239E46"
            fillRule="evenodd"
            d="m8.197 4.819-.454.531c-.017.02-.05.004-.043-.022l.156-.663h-.71c-.027 0-.035-.037-.01-.048l.607-.265-.43-.568c-.016-.02.005-.047.028-.038l.677.264.155-.622c.006-.025.042-.025.048 0l.154.622.67-.262c.025-.009.045.02.03.04l-.466.564.642.265c.025.01.017.048-.01.048H8.61l.096.678c.004.025-.027.04-.043.02l-.465-.545ZM7.8 6.5h2.4v.525H7.8V6.5Z"
            clipRule="evenodd"
          />
          <Path
            fill="#C51918"
            fillRule="evenodd"
            d="M7.436 6.196h-.002a.11.11 0 0 1-.051.065.192.192 0 0 1-.105.025.234.234 0 0 1-.094-.018.198.198 0 0 1-.073-.055.259.259 0 0 1-.047-.089.398.398 0 0 1-.018-.122c0-.046.006-.086.017-.122a.247.247 0 0 1 .048-.089.206.206 0 0 1 .075-.055.245.245 0 0 1 .098-.018c.05 0 .092.01.126.033.033.022.06.05.077.087l-.055.033a.155.155 0 0 0-.057-.07.16.16 0 0 0-.091-.024.17.17 0 0 0-.067.013.153.153 0 0 0-.087.093.216.216 0 0 0-.012.074v.089a.22.22 0 0 0 .012.074.15.15 0 0 0 .088.094.197.197 0 0 0 .127.006.137.137 0 0 0 .046-.023.106.106 0 0 0 .042-.09v-.055H7.31v-.058h.188v.283h-.062v-.08Zm.418-.469v.34c0 .053.01.092.03.12.019.027.054.04.103.04.05 0 .084-.013.104-.04a.201.201 0 0 0 .03-.12v-.34h.067v.324a.44.44 0 0 1-.01.104.181.181 0 0 1-.036.074.143.143 0 0 1-.062.043.278.278 0 0 1-.095.014.27.27 0 0 1-.094-.014.138.138 0 0 1-.061-.043.18.18 0 0 1-.034-.074.475.475 0 0 1-.01-.104v-.324h.068Zm.978.55-.056-.163H8.55l-.056.163h-.068l.196-.55h.085l.195.55h-.07Zm-.167-.489H8.66l-.095.268h.193l-.094-.268Zm.925.026h-.004l-.047.092-.133.24-.134-.24-.047-.092H9.22v.463h-.066v-.55h.09l.16.296h.004l.16-.296h.087v.55H9.59v-.463Z"
            clipRule="evenodd"
          />
        </G>
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
